<template>
  <div class="wt-custom-page" :key="currentPage.id">
    <layout-custom>
      <layout-header slot="header" />
      <main-stage ref="mainStage" slot="main">
        <custom-overlays-stage />
      </main-stage>
      <custom-overlays-fields slot="left" :stage-rect="stageRect" />
      <template slot="bottom">
        <custom-overlays-indication v-if="showBottomIndication" />
        <div v-if="trackingFailed" class="custom-overlays-indication">
          <span class="warning">{{ trackingFailedText }}</span>
        </div>
      </template>
      <custom-overlays-apply-cancel slot="footer" />
    </layout-custom>
  </div>
</template>

<script>
import app from 'app';
import LayoutCustom from 'AssetEditor/layouts/LayoutCustom.vue';
import LayoutHeader from 'AssetEditor/layouts/LayoutHeader.vue';
import CustomOverlaysApplyCancel from 'AssetEditor/functionality/CustomOverlays/CustomOverlaysApplyCancel.vue';
import CustomOverlaysIndication from 'AssetEditor/functionality/CustomOverlays/CustomOverlaysIndication.vue';
import CustomOverlaysFields from 'AssetEditor/functionality/CustomOverlays/CustomOverlaysFields.vue';
import CustomOverlaysStage from 'AssetEditor/functionality/CustomOverlays/CustomOverlaysStage.vue';
import MainStage from 'AssetEditor/functionality/Stage/MainStage.vue';
import { getSegmentTimes } from 'AssetEditor/functionality/CustomOverlays/objectTrackingApi';
import { mapGetters, mapMutations } from 'vuex';

export default {
  components: {
    LayoutCustom,
    LayoutHeader,
    CustomOverlaysApplyCancel,
    CustomOverlaysIndication,
    CustomOverlaysFields,
    CustomOverlaysStage,
    MainStage,
  },

  data() {
    return {
      stageRect: null,
    };
  },

  computed: {
    ...mapGetters('assetEditor', [
      'isPageExistsInThemeInfo',
      'currentPage',
      'workModel',
      'tmpAGD',
    ]),

    showBottomIndication() {
      return !this.isPageExistsInThemeInfo({
        childId: this.currentPage.id,
        layer: this.currentPage.layers && this.currentPage.layers[0],
        index: 0,
      });
    },

    /**
     * The tracking job belonging to the overlay being edited, if any.
     */
    objectTrackingId() {
      const co = _.find(this.tmpAGD.customOverlays || [], {
        id: this.currentPage.id,
      });

      return co && co.objectTrackingId;
    },

    trackingFailed() {
      return (
        !!this.objectTrackingId &&
        app.objectTrackingController.hasFailed(this.objectTrackingId)
      );
    },

    trackingFailedText() {
      return app.culture.get('assetEditor.objectTrackingFailedIndication');
    },
  },

  watch: {
    // every custom overlay renders through this same component instance, so
    // switching overlays does not re-run mounted - re-take the baseline here
    'currentPage.id': function () {
      this.captureTrackingBaseline();
    },
  },

  mounted() {
    this.stageRect = this.$refs.mainStage.$el.getBoundingClientRect();
    this.captureTrackingBaseline();
  },

  methods: {
    ...mapMutations('assetEditor', ['setTmpPageState', 'setTimeInAsset']),

    /**
     * What the segment looked like when this overlay was opened - compared on
     * apply to decide whether the tracking job has to be recreated.
     *
     * The playhead is reset too: it is never cleared between pages, and object
     * tracking reads it as the moment the boxes were positioned on, so a
     * position left over from another page would be sent as the reference time.
     */
    captureTrackingBaseline() {
      this.setTimeInAsset(0);
      this.setTmpPageState({
        trackingBaseline: getSegmentTimes(this.workModel),
      });
    },
  },
};
</script>
